import {
  SET_MESSAGE_HOT,
  UPDATE_MESSAGE_HOT,
  SET_MESSAGE_COLLECT_LIST,
  SET_MESSAGE_COMMENT_LIST,
  RESET_MESSAGE_LIST,
  SET_MESSAGE_COLLECT_LOADING,
  SET_MESSAGE_COMMENT_LOADING,
  UPDATE_MESSAGE_LIST,
} from '../constants/message';
import Ignore from '../pages/Update/Ignore';

const initState = {
  hot: {}, // 小红点
  hasMessage: false,
  commentList: [],
  commentPagenation: {
    count: 0,
  },
  commentLoading: false,
  collectList: [],
  collectPagenation: {
    count: 0,
  },
  collectLoading: false,
};

const message = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_MESSAGE_HOT:
      // eslint-disable-next-line no-case-declarations
      const hasMessage = Object.keys(action.payload).reduce((result, key) => {
        return result || action.payload[key] === '1';
      }, false);
      return { ...state, hot: action.payload, hasMessage };
    case UPDATE_MESSAGE_HOT:
      // eslint-disable-next-line no-case-declarations
      const tempHot = {
        ...state.hot,
        [action.payload.code]: '0',
      };
      // eslint-disable-next-line no-case-declarations
      const hasmessage = Object.keys(tempHot).reduce((result, key) => {
        return result || tempHot[key] === 1;
      }, false);
      return { ...state, hot: tempHot, hasMessage: hasmessage };
    case SET_MESSAGE_COMMENT_LIST:
      // eslint-disable-next-line no-case-declarations
      const tempCommentList = action.payload.params.refresh
        ? action.payload.list
        : [...state.commentList, ...action.payload.list];
      return {
        ...state,
        commentList: tempCommentList,
        commentPagenation: {
          count:
            action.payload.list.length === 0 ||
            action.payload.list.length < action.payload.params.limit
              ? tempCommentList.length
              : tempCommentList.length + 1,
        },
      };
    case SET_MESSAGE_COLLECT_LIST:
      // eslint-disable-next-line no-case-declarations
      const tempCollectList = action.payload.refresh
        ? action.payload.list
        : [...state.collectList, ...action.payload.list];

      return {
        ...state,
        collectList: tempCollectList,
        collectPagenation: {
          count:
            action.payload.list.length === 0 ||
            action.payload.list.length < action.payload.params.limit
              ? tempCollectList.length
              : tempCollectList.length + 1,
        },
      };

    case RESET_MESSAGE_LIST:
      return {
        ...state,
        commentList: [],
        commentPagenation: {
          count: 0,
        },
        collectList: [],
        collectPagenation: {
          count: 0,
        },
      };
    case SET_MESSAGE_COLLECT_LOADING:
      return {
        ...state,
        collectLoading: action.payload,
      };
    case SET_MESSAGE_COMMENT_LOADING:
      return {
        ...state,
        commentLoading: action.payload,
      };
    case UPDATE_MESSAGE_LIST:
      // eslint-disable-next-line no-case-declarations
      let tempobj = {};
      // if (action.tab === 'comment') {
      tempobj = {
        commentList: state.commentList.map(item => ({
          ...item,
          hasZan: action.payload.originalCommentId === item.commentId ? true : item.hasZan,
        })),
      };
      // } else {
      //   tempobj = {
      //     collectList: state.collectList.map(item => ({ ...item, hasZan: true })),
      //   };
      // }
      return {
        ...state,
        ...tempobj,
      };
    default:
      return state;
  }
};

export default message;
